import axios from 'axios';
import { BASE_URL } from '@/assets/js/config';
import { getAccessToken } from '@/assets/js/auth';

export const getCredentials = async (apiUrl, region) => {
    let userData = JSON.parse(localStorage.getItem('user_id')).find(item => item.name === region);
    let tokens = JSON.parse(localStorage.getItem('region_tokens'));
    let regionTokenData = tokens.find(item => item.name === region);
    const settings = {
      headers: {
        'X-Auth-Token': regionTokenData.token,
      }
    };

    return axios.get(`${apiUrl}/users/${userData.id}/credentials/OS-EC2`, settings);
}

export const createCredential = async (apiUrl, region) => {
    let userData = JSON.parse(localStorage.getItem('user_id')).find(item => item.name === region);
    let tokens = JSON.parse(localStorage.getItem('region_tokens'));
    let regionTokenData = tokens.find(item => item.name === region);
    let projectId = JSON.parse(localStorage.getItem('current_project'))[region];
    if (projectId == undefined) {
        if (region === 'core') {
            projectId = JSON.parse(localStorage.getItem('current_project')).ams2;
        } else if (region === 'stagingamstwo') {
            projectId = JSON.parse(localStorage.getItem('current_project')).staging102;
        } else if (region === 'stagingamsthree') {
            projectId = JSON.parse(localStorage.getItem('current_project')).staging101;
        }
    }
    let data = {
        "tenant_id": projectId,
    }
    const settings = {
        headers: {
            'X-Auth-Token': regionTokenData.token,
        }
    };

    return axios.post(`${apiUrl}/users/${userData.id}/credentials/OS-EC2`, data, settings);
}

export const deleteCredential = async (apiUrl, credentialId, region) => {
    let userData = JSON.parse(localStorage.getItem('user_id')).find(item => item.name === region);
    let tokens = JSON.parse(localStorage.getItem('region_tokens'));
    let regionTokenData = tokens.find(item => item.name === region);
    let projectId = JSON.parse(localStorage.getItem('current_project'))[region];
    if (projectId == undefined) {
        if (region === 'core') {
            projectId = JSON.parse(localStorage.getItem('current_project')).ams2;
        } else if (region === 'stagingamstwo') {
            projectId = JSON.parse(localStorage.getItem('current_project')).staging102;
        } else if (region === 'stagingamsthree') {
            projectId = JSON.parse(localStorage.getItem('current_project')).staging101;
        }
    }
    let data = {
        "tenant_id": projectId,
    }
    const settings = {
        headers: {
            'X-Auth-Token': regionTokenData.token,
        }
    };

    return axios.delete(`${apiUrl}/users/${userData.id}/credentials/OS-EC2/${credentialId}`, settings);
}

// APPLICATION CREDENTIAL
export const getApplicationCredentials = async (apiUrl, region) => {
    let userData = JSON.parse(localStorage.getItem('user_id')).find(item => item.name === region);
    let tokens = JSON.parse(localStorage.getItem('region_tokens'));
    let regionTokenData = tokens.find(item => item.name === region);
    const settings = {
      headers: {
        'X-Auth-Token': regionTokenData.token,
      }
    };

    return axios.get(`${apiUrl}/users/${userData.id}/application_credentials`, settings);
}

export const createApplicationCredential = async (apiUrl, data, region) => {
    let userData = JSON.parse(localStorage.getItem('user_id')).find(item => item.name === region);
    let tokens = JSON.parse(localStorage.getItem('region_tokens'));
    let regionTokenData = tokens.find(item => item.name === region);
    const settings = {
      headers: {
        'X-Auth-Token': regionTokenData.token,
      }
    };

    return axios.post(`${apiUrl}/users/${userData.id}/application_credentials`, data, settings);
}

export const deleteApplicationCredential = async (apiUrl, appCredId, region) => {
    let userData = JSON.parse(localStorage.getItem('user_id')).find(item => item.name === region);
    let tokens = JSON.parse(localStorage.getItem('region_tokens'));
    let regionTokenData = tokens.find(item => item.name === region);
    const settings = {
      headers: {
        'X-Auth-Token': regionTokenData.token,
      }
    };

    return axios.delete(`${apiUrl}/users/${userData.id}/application_credentials/${appCredId}`, settings);
}

export const getAccessRules = async (apiUrl, region) => {
    let userData = JSON.parse(localStorage.getItem('user_id')).find(item => item.name === region);
    let tokens = JSON.parse(localStorage.getItem('region_tokens'));
    let regionTokenData = tokens.find(item => item.name === region);
    const settings = {
      headers: {
        'X-Auth-Token': regionTokenData.token,
      }
    };

    return axios.get(`${apiUrl}/users/${userData.id}/access_rules`, settings);
}

export const deleteAccessRule = async (apiUrl, ruleId, region) => {
    let userData = JSON.parse(localStorage.getItem('user_id')).find(item => item.name === region);
    let tokens = JSON.parse(localStorage.getItem('region_tokens'));
    let regionTokenData = tokens.find(item => item.name === region);
    const settings = {
      headers: {
        'X-Auth-Token': regionTokenData.token,
      }
    };

    return axios.delete(`${apiUrl}/users/${userData.id}/access_rules/${ruleId}`, settings);
}
